import { ProposalType, UserSegmentType } from '~/types/userTypes';
import { appApi } from '~/redux/api/appApiSlice';

export const aqarConnectApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserSegment: builder.query<
      UserSegmentType,
      { userSegment: string | undefined; locale: string }
    >({
      query: ({ userSegment, locale }) => {
        return {
          url: `/api/v2/leads-bank/user-segment/${userSegment}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
    }),
    getProposal: builder.query<
      ProposalType,
      { id: string | undefined; locale: string; _hash: string }
    >({
      query: ({ id, locale, _hash }) => {
        return {
          url: `/api/v2/leads-bank/proposal/lookup/${id}?_hash=${encodeURIComponent(_hash)}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
    }),
    acceptProposal: builder.mutation<
      any,
      { proposalId: string | undefined; _hash: string; _locale: string }
    >({
      query: ({ _hash, _locale, proposalId }) => {
        return {
          url: `api/v2/leads-bank/proposal/${proposalId}/accept?_hash=${encodeURIComponent(_hash)}&_locale=${_locale}`,
          headers: {
            'Accept-Language': _locale,
          },
        };
      },
    }),
    rejectProposal: builder.mutation<
      any,
      { proposalId: string | undefined; _hash: string; _locale: string }
    >({
      query: ({ _hash, _locale, proposalId }) => {
        return {
          url: `api/v2/leads-bank/proposal/${proposalId}/reject?_hash=${encodeURIComponent(_hash)}&_locale=${_locale}`,
          method: 'POST',
          headers: {
            'Accept-Language': _locale,
          },
        };
      },
    }),
  }),
});

export const {
  useGetUserSegmentQuery,
  useAcceptProposalMutation,
  useGetProposalQuery,
  useRejectProposalMutation,
} = aqarConnectApiSlice;
